import { createContext, FC, ReactNode, useState } from 'react';

interface Props {
  children?: ReactNode;
}

interface ViewProps {
  view: string;
  setCurrentView: (view: string) => void;
}

export const CurrentViewContext = createContext<ViewProps>({
  view: '',
  setCurrentView: () => {},
});

const CurrentViewProvider: FC<Props> = ({ children }) => {
  const [view, setView] = useState('');

  const setCurrentView = (view: string) => {
    setView(() => view);
  };

  return (
    <CurrentViewContext.Provider value={{ view, setCurrentView }}>
      {children}
    </CurrentViewContext.Provider>
  );
};

export default CurrentViewProvider;
